import React, { useState, useEffect } from "react";
import AudioFileList from "./components/AudioFileList";
import MoodWindow from "./components/MoodWindow";
import styles from "./Home.module.scss";
import Header from "./components/Header";

const Home = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {isMobileView ? (
        <div className={styles.container}>
          <Header />
          <MoodWindow />
          <AudioFileList />
        </div>
      ) : (
        <div className={styles.container}>
          <Header />

          <AudioFileList />
          <MoodWindow />
        </div>
      )}
    </>
  );
};

export default Home;
